import qs from 'qs';
import React from 'react';
import PropTypes from 'prop-types';
import request from '../../request';
import Input from '../shared/input';
import Submit from '../shared/submit';

export default class FinishSignup extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {};
  }
  componentWillMount() {
    localStorage.clear();
  }

  async signup() {
    let { match } = this.props;
    let { password, password_confirmation, loading } = this.state;
    if (loading) return;
    try {
      this.setState({ loading: true });
      let { token, id, type } = await request({
        url: `invites/finish/`,
        body: {
          password_confirmation,
          password,
          token: decodeURIComponent(match.params.code),
          email: decodeURIComponent(match.params.email),
        },
      });

      localStorage.setItem('token', token);
      localStorage.setItem('type', type);
      localStorage.setItem('user_id', id);
      this.context.router.history.push('/');
    } catch (error) {
      this.setState({ error: error, loading: false });
    }
  }

  render() {
    let { location } = this.props;
    let query = qs.parse(location.search.substring(1));

    let { error, loading } = this.state;
    return (
      <div id="main" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5>New Password</h5>
        {query.message
          ? <p className="fail">
              {query.message}
            </p>
          : null}
        {error
          ? <p className="fail">
              {error.message || error}
            </p>
          : null}
        <Input
          name="password"
          type="password"
          className="password"
          placeholder="Password"
          onChange={password => this.setState({ password })}
        />
        <Input
          name="password_verify"
          type="password"
          className="password"
          placeholder="Password Confirmation"
          onChange={password_confirmation =>
            this.setState({ password_confirmation })}
          onEnter={() => this.signup()}
        />
        <Submit onClick={() => this.signup()} id="send" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/finish.js